import React from 'react'

const TotalPremiumBanner = ({
  lowMileagePremiumTotal,
  comprehensivePremiumTotal,
  backgroundColor,
  underlineColor,
  hideLowMileageTotal = false,
  hideAllMileageTotals = false
}) => {

  const lowMileageTotalValue = parseFloat(lowMileagePremiumTotal).toFixed(2);
  const comprehensivePremiumTotalValue = parseFloat(comprehensivePremiumTotal).toFixed(2)
  const defaultUnderlineColour = '#a6d7dc'

  return (
    <div className='premium-totals-banner-wrapper' style={{ backgroundColor: backgroundColor ?? '#7fc6cd' }}>
      <div className='premium-totals-banner-left-wrapper'>
        <p className='premium-total-main-heading'>TOTAL</p>
      </div>

      <div className='premium-totals-banner-right-wrapper'>
        <div className='premium-totals-banner-right-content-wrapper' style={hideLowMileageTotal ? { justifyContent: 'flex-end', marginRight: 40 } : {}}>
          {!hideAllMileageTotals &&
            <>
              {!hideLowMileageTotal &&
                <div className='premium-totals-banner-inner-content-left'>
                  <p className='mileage-heading'>Under 300KM <sub className='mileage-heading-subscript'>P/M</sub></p>
                <p className='premium-heading' style={{ borderTopColor: underlineColor ?? defaultUnderlineColour }}>
                    {`R${lowMileageTotalValue}`}
                  </p>
                </div>
              }
            <div className='premium-totals-banner-inner-content-right' style={hideLowMileageTotal ? { flexGrow: 0 } : {}}>
              <p className='mileage-heading'>Over 300KM <sub className='mileage-heading-subscript'>P/M</sub></p>
              <p className='premium-heading' style={{ borderTopColor: underlineColor ?? defaultUnderlineColour }}>
                {`R${comprehensivePremiumTotalValue}`}
              </p>
            </div>
            </>
          }
          {hideAllMileageTotals &&
            <div className='premium-totals-banner-inner-content-right' style={{ flexGrow: 0 }}>
              <p className='mileage-heading'>Premium <sub className='mileage-heading-subscript'>P/M</sub></p>
              <p className='premium-heading' style={{ borderTopColor: underlineColor ?? defaultUnderlineColour }}>
                {`R${comprehensivePremiumTotalValue}`}
              </p>
            </div>
          }
        </div>
      </div>
    </div >
  )
}

export default TotalPremiumBanner
